export default {
  LOGIN: "/login",
  EMPLOYEES: "/employees",
  CHAPTERS_MASTER: "/master",
  CHAPTERS_MASTER_DETAILS: "/master/details/",
  CHAPTERS_MASTER_UPDATE: "/master/update/",
  STATE_FEDERATION_CREATE: "/state/fed/create",
  STATE_FEDERATION_UPDATE: "/state/fed/update/",
  NATIONAL_MEMBER_DETAIL: "/national/member/detail",
  STATE_MEMBER_DETAIL: "/state/member/detail/",
  CITY_MEMBER_DETAIL: "/city/member/detail/",
  CITY_ASSOCIATION_LIST: "/city/list/",
  CITY_ASSOCIATION_CREATE: "/city/create",
  CITY_ASSOCIATION_UPDATE: "/city/update/",

  ADMIN: "/admin",
  ADMIN_CREATE: "/admin/create",
  ADMIN_UPDATE: "/admin/update/",
  ADMIN_DETAILS: "/admin/details/",

  MEMBERS: "/members",
  MEMBERS_CREATE: "/member/create",
  MEMBERS_UPDATE: "/member/update/",
  MEMBERS_DETAILS: "/member/details/",

  NEW_MEMBERS: "/user/request",
  NEW_MEMBERS_CREATE: "/user/request/create",
  NEW_MEMBERS_UPDATE: "/user/request/update/",
  NEW_MEMBERS_DETAILS: "/user/request/details/",

  ALBUMS: "/album",
  ALBUMS_CREATE: "/album/create",
  ALBUMS_UPDATE: "/album/update/",
  ALBUMS_DETAILS: "/album/details/",
  ALBUMS_UPDATE_CREATE: "/details/create",

  POLICIES: "/policies",
  POLICIES_CREATE: "/policies/create",
  POLICIES_UPDATE: "/policies/update/",
  POLICIES_DETAILS: "/policies/details/",

  NOTIFICATION: "/notification",
  NOTIFICATION_CREATE: "/notification/create",
  NOTIFICATION_UPDATE: "/notification/update/",

  EVENTS: "/events",
  EVENTS_SCEDULE: "/events/schedule/",
  EVENTS_CREATE: "/event/create",
  EVENT_BASIC_CREATE:"/event/basic/create",
  EVENT_BASIC_UPDATE:"/event/basic/update/",
  EVENTS_UPDATE: "/event/update/",
  EVENTS_DETAILS: "/event/details/",

  EVENTS_SPEAKERS_LIST: "/events/speakers/",
  ADD_SPEAKERS_CREATE: "/speakers/create",
  ADD_SPEAKERS_UPDATE: "/speakers/update/",

  APP: "/app",
  USER_PROFILE: "/app/user-profile/",
  FEED_POSTS: "/app/feed-post/",
  COMMENTS: "/app/comments/",
  ASSOCIATED_EVENTS: "/app/associate-events/",
  ASSOCIATED_CHAPTERS: "/app/associate-chapters/",
  EVENT_CITYGUIDE: "/cityguide/",
  EVENT_CITYGUIDE_CREATE: "/guide/create",
  EVENT_CITYGUIDE_UPDATE: "/guide/update/",
  CITYGUIDE_CONTENT_CREATE: "/cityguide/content/create",
  CITYGUIDE_CONTENT_UPDATE: "/city/contents/update/",
  CITYGUIDE_CONTENT_LIST: "/city/content/",
  REPORTED_USER: "/reported/user",
  REPORTED_FEED: "/reported/feed",
  MEMBER_POLLS:"/member/polls",
  MEMBER_POLLS_CREATE:"/member/polls/create",
  MEMBER_POLLS_UPDATE:"/member/polls/update/",
  INFOR_CENTER: "/events/information/center/",
  INFOR_CENTER_CREATE: "/information/center/create",
  INFOR_CENTER_UPDATE: "/information/center/update/",

  PENDING_EVENTS: "/pending/events",
  PENDING_EVENTS_DETAILS: "/pending/events/details/",

  EVENT_PARTICIPANTS: "/event/participants/",
  EVENT_POLLS: "/event/polls/",
  EVENT_POLLS_CREATE: "/polls/create",
  EVENT_POLLS_UPDATE: "/polls/update/",

  EVENT_ORGANISERS: "/event/organisers/",
  EVENT_ORGANISER_USER: "/event/organisers/users/",
  EVENT_ORGANISER_USER_CREATE: "/organisers/users/create/",
  EVENT_ORGANISER_USER_UPDATE: "/organisers/users/update/",
  EVENT_ORGANISER_USER_DETAIL: "/organisers/users/create/detail",

  EVENT_SPONSOR: "/event/sponsor/",
  EVENT_SPONSOR_TYPE: "/sponsor/type/",

  EVENT_SPONSOR_USER: "/event/sponsor/users/",
  EVENT_SPONSOR_CREATE: "/event/sponsor/users/create",
  EVENT_SPONSOR_UPDATE: "/event/sponsor/update/",

  EVENT_SPONSOR_TYPE_CREATE: "/event/sponsor/type/create",
  EVENT_SPONSOR_TYPE_UPDATE: "/event/sponsor/type/update/",

  EVENT_DESK_USER: "/event/desk/",
  EVENT_DESK_CREATE: "/desk/users/create",
  EVENT_DESK_UPDATE: "/desk/user/update/",

  EVENT_CATEGORY_USER: "/event/category/",
  EVENT_CATEGORY_CREATE: "/desk/category/users/create",
  EVENT_CATEGORY_UPDATE: "/desk/category/update/",

  EVENT_GALLERY: "/event/gallery/",
  EVENT_FEED: "/event/feed/",

  EVENT_BANNER: "/event/banner/",
  EVENT_BANNER_CREATE: "/event/banners/create",
  EVENT_BANNER_UPDATE: "/event/banners/update/",

  YOUTUBE_STREEM: "/event/youtube/",
  YOUTUBE_STREEM_CREATE: "/youtube/create",

  EVENT_USERLIST: "/event/user",

  MEMBER_COMPANY: "/member/company",

  BUSINESS_GREETING: "/business-list",
  BUSINESS_GREETING_CREATE: "/business-list/create",
  BUSINESS_GREETING_DETAIL: "/business-greeting-detail",

  KNOWLEDGE_CENTER: "/knowledge-center",
  KNOWLEDGE_CENTER_CREATE: "/knowledge-center/create",
  KNOWLEDGE_CENTER_UPDATE: "/knowledge-center/update",

  /*Stamp Center is here*/
  KNOWLEDGE_CENTER_LIST: "/knowledge-center/list",
  KNOWLEDGE_CENTER_STAMP_CREATE: "/stamp/create",
  KNOWLEDGE_CENTER_STAMP_UPDATE: "/stamp/update",

  EMAIL_COM_LIST: "/email/composer",
  EMAIL_BLOCKED_USER: "/email/blocked/user",
  EMAIL_COM_CREATE: "/email/composer/create",
  EMAIL_COM_DUPLICATE: "/email/composer/duplicate/",
  EMAIL_COM_DETAIL: "/email/composer/detail/",
  EMAIL_COM_UPDATE: "/email/com/update/",
  LETTERHEAD_LIST: "/letterhead/list",
  LETTERHEAD_CREATE: "/letterhead/create",
  LETTERHEAD_UPDATE: "/letterhead/update/",
  WHATSAPP_LIST: "/whatsapp/list",
  WHATSAPP_CREATE: "/whatsapp/create",
  WHATSAPP_DETAIL: "/whatsapp/detail/",
  WHATSAPP_UPDATE: "/whatsapp/update/",
  BROADCAST_LIST: "/broadcast/list",
  BROADCAST_CREATE: "/broadcast/create",
  BROADCAST_DETAIL: "/broadcast/detail/",
  E_LIBRARY: "/library",
  SECTION_ENGAGEMENT: "/section/all",
  BLOCKED_USER: "/blocked/user",
  PREFERRED_PARTNER: "/preferred/partner",
  PREFERRED_PARTNER_TYPE: "/partner/type",
  PREFERRED_PARTNER_CREATE: "/preferred/partner/create",
  PREFERRED_PARTNER_UPDATE: "/preferred/partner/update/",
  PREFERRED_PARTNER_TYPE_CREATE: "/partner/type/create",
  PREFERRED_PARTNER_TYPE_UPDATE: "/partner/type/update/",

  VENDOR_LIST: "/vendor",
  VENDOR_CREATE: "/vendor/create",
  VENDOR_UPDATE: "/vendor/update/",
  CATEGORY: "/category",
  SUB_CATEGORY: "/sub/category/",
  LANYARD_TEMPLATE: "/lanyard/template/list",
  LANYARD_TEMPLATE_CREATE: "/lanyard/template/create",
  LANYARD_TEMPLATE_UPDATE: "/lanyard/template/update/",

  PRIMARY_USER_UPDATE_LIST:"/primary/user/update",
  PRIMARY_USER_UPDATE:"/primary/user/update/",
  VENDOR_APPROVAL_LIST:"/vendor/approvals",
  VENDOR_APPROVAL_DETAIL:"/vendor/approvals/detail"
};
